import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from './button.component';

@Component({
  selector: 'app-close-btn',
  templateUrl: './button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloseBtnComponent extends ButtonComponent {
  constructor() {
    super();
    this.icon = 'close';
    this.label = $localize`Zamknij`;
    this.style = 'primary';
  }
}
